import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SiNoChip } from "src/pages/sistema/components/FieldView";
import { OperacionCFFields } from "../types/fields";

type SeccionCFDetalleTransaccionProps = {
  operacion: any;
}

const SeccionCFDetalleTransaccion = ({ operacion }: SeccionCFDetalleTransaccionProps) => {
  if (!operacion) return null;

  return (
    <CardActions title='Detalle de la Transacción' icon='mdi:file-document-edit-outline' colapsable>
      <Grid container spacing={2.5} rowSpacing={2.5}>

        <Grid item xs={12} >
          <FieldView label='Success fee (%)' value={operacion[OperacionCFFields.SuccessFee]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Monto mínimo success fee (USD)' value={operacion[OperacionCFFields.MontoMinimoSuccess]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Meses de retainer' value={operacion[OperacionCFFields.CantMesesRetainer]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Monto de retainer mensual (USD)' value={operacion[OperacionCFFields.MontoRetainerMensual]} />
        </Grid>

        <Grid item xs={6} md={4}>
          <FieldView label='Acreditación de retainer mensual'>
            <SiNoChip value={operacion[OperacionCFFields.AcreditacionRetainerMensual]} />
          </FieldView>
        </Grid>

        <Grid item xs={6} md={4}>
          <FieldView label='Exclusividad'>
            <SiNoChip value={operacion[OperacionCFFields.Exclusividad]} />
          </FieldView>
        </Grid>

      </Grid>
    </CardActions>
  );
};

export default SeccionCFDetalleTransaccion;